import * as React from 'react';
import { FrameImage } from '../../steps/components/FrameImage/FrameImage.js';
import { ConfigurationSummaryContainer } from '../ConfigurationSummary/ConfigurationSummaryContainer.js';
import { PrescriptionSummaryContainer } from '../PrescriptionSummary/PrescriptionSummaryContainer.js';

const SelectionsSummary = ()=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "selections-summary"
    }, /*#__PURE__*/ React.createElement(FrameImage, null), /*#__PURE__*/ React.createElement(ConfigurationSummaryContainer, null), /*#__PURE__*/ React.createElement(PrescriptionSummaryContainer, {
        className: "selections-summary__rx"
    }));
};

export { SelectionsSummary };
//# sourceMappingURL=SelectionsSummary.js.map
